import { useState, useEffect } from 'react';
import apiClient from 'helpers/api-client';
import errorLogger from 'helpers/error-logger';
import { ProjectContact } from 'data/v1/data-contracts';

type UseGetProjectContactsProps = {
  projectDbId: number;
  onSuccess?: () => void;
  onError?: () => void;
};

const useGetProjectContacts = ({
  projectDbId,
  onSuccess = () => {},
  onError = () => {},
}: UseGetProjectContactsProps) => {
  const [contacts, setContacts] = useState<ProjectContact[]>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await apiClient.get(
          `locations/${projectDbId}/contacts`,
        );

        setContacts(response && response.length > 0 ? response : []);
        onSuccess();
      } catch (err) {
        onError();
        errorLogger({
          error: err,
          consoleMessage: 'Error loading project contact',
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchContacts();
  }, [projectDbId]);

  return { contacts, isLoading };
};

export default useGetProjectContacts;
